export type SendCustomEventsBatchRequest = {
  events: Array<{
    event_name: string;
    params: Record<string, string>;
    user_id: string;
  }>;
};

export const sendStatsBatch = async (
  request: SendCustomEventsBatchRequest,
  statsUrl: string,
  asBeacon?: boolean,
) => {
  const url = `${statsUrl}/v1/send_custom_event_batch`;
  if (asBeacon) {
    try {
      const blob = new Blob([JSON.stringify(request)], {
        type: 'application/json',
      });
      navigator.sendBeacon(url, blob);
      return;
    } catch (error) {
      console.warn('Failed to send beacon with stats', error);
    }
  }
  fetch(url, {
    method: 'POST',
    body: JSON.stringify(request),
    headers: {
      'content-type': 'application/json',
    },
  }).catch((error) => {
    console.warn('Failed to send stats', error);
  });
};
